exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-box[data-v-9d4d97a0] .yxt-select{width:328px}\n", ""]);

